module.exports = __webpack_public_path__ + "static/media/fT.b82c3e9b.png";